import { render, staticRenderFns } from "./BloodTypeUpdate.vue?vue&type=template&id=73d4cf33&"
import script from "./BloodTypeUpdate.vue?vue&type=script&lang=js&"
export * from "./BloodTypeUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports